import React, { createContext, useContext, useState } from 'react';
import { deleteData, fetchData, postData, putData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';

const HorarioExcecaoContext = createContext();

export const useHorarioExcecao = () => useContext(HorarioExcecaoContext);

export const HorarioExcecaoProvider = ({ children }) => {
    const { showAlert } = useAlert();

    const [excecaoNaoFinalizadas, setExcecaoNaoFinalizadas] = useState(null);
    const [excecaoAtiva, setExcecaoAtiva] = useState(null);
    

    const fetchExcecaoAtiva = async () => {
        try {
            const result = await fetchData('/HorarioExcecao/ativa');
            setExcecaoAtiva(result);
        } catch (error) {
            console.error("Erro ao buscar exceção ativa:", error);
        }
    };

    const fetchExcecaoNaoFinalizadas = async () => {
        try {
            const result = await fetchData('/HorarioExcecao/nao-finalizadas');
            setExcecaoNaoFinalizadas(result);
        } catch (error) {
            console.error("Erro ao buscar exceção não finalizada:", error);
        }
    };

    // useEffect(() => {
    //     fetchExcecaoNaoFinalizadas();
    //     fetchExcecaoAtiva();
    // }, []);

    const insertExcecao = async (data) => {
        try {
            await postData('/HorarioExcecao', data);
            await fetchExcecaoNaoFinalizadas();
            showAlert('Exceção cadastrada com sucesso!');
        } catch (error) {
            showAlert('Erro ao cadastrar exceção!', 'danger');
        }
    };

    const updateExcecao = async (data) => {
        try {
            const result = await putData('/HorarioExcecao', data);
            setExcecaoNaoFinalizadas(result);
            showAlert('Exceção atualizada com sucesso!');
        } catch (error) {
            showAlert('Erro ao atualizar exceção!', 'danger');
        }
    };

    const deleteExcecao = async (id) => {
        try {
            await deleteData(`/HorarioExcecao/${id}`);

            // Atualiza lista removendo do state
            setExcecaoNaoFinalizadas(prev =>
                prev.filter(e => e.id !== id)
            );

            showAlert('Exceção excluída com sucesso!');
        } catch (error) {
            showAlert('Erro ao excluir exceção!', 'danger');
        }
    };


    return (
        <HorarioExcecaoContext.Provider
            value={{
                excecaoAtiva,
                excecaoNaoFinalizadas,
                fetchExcecaoAtiva,
                fetchExcecaoNaoFinalizadas,
                insertExcecao,
                updateExcecao,
                deleteExcecao
            }}
        >
            {children}
        </HorarioExcecaoContext.Provider>
    );
};